import initConfig from './init-config'

export function demo(widgetType, shouldUseDemoContent = true, selector = 'body', position = 'afterbegin') {
  document.querySelector(selector).insertAdjacentHTML(position, `<div data-8select-widget-id="${widgetType}"></div>`)
  if (shouldUseDemoContent === true) {
    window._eightselect_config.isDemoMode = true
    this.config = initConfig()
  } else {
    window._eightselect_config.isDemoMode = false
    this.config = initConfig()
  }

  this.initCSE()
}
